module.exports = __webpack_public_path__ + "img/bg_dietz.d3791034.png";